export default __webpack_public_path__ + "static/media/penyFailure.c02b2ccd.png";